import customAxios from './axios';
import CONFIG from '../../config';

export const createAdditionalPaymentRequest = (payload) => {
    return customAxios.post( CONFIG.apiURL + '/AdditionalPaymentRequest/Create', payload).then(res => {
        return res;
    });
};

export const getAllAdditionalPayments = () => {
    return customAxios.get( CONFIG.apiURL + '/ActiveAdditionalPaymentTypes').then(res => {
        let response = res['data'];
        return response;
    });
};

export const additionalPaymentRequests = (id) => {
    return customAxios.get( CONFIG.apiURL + `/AdditionalPaymentRequests/GetByJob?jobId=${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getParticularAdditionalPayment = (id) => {
    return customAxios.get( CONFIG.apiURL + `/AdditionalPaymentRequest/${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const updateAdditionalPaymentRequest = (payload) => {
    return customAxios.put( CONFIG.apiURL + '/AdditionalPaymentRequest/Update', payload).then(res => {
        return res;
    });
};

export const createAdditionalPaymentReference = (payload) => {
    return customAxios.post( CONFIG.apiURL + '/AdditionalPaymentReference/Create', payload).then(res => {
        return res;
    });
};

export const updateAdditionalPaymentReference = (payload) => {
    return customAxios.put( CONFIG.apiURL + '/AdditionalPaymentReference/Update', payload).then(res => {
        return res;
    });
};

export const statusLogs = (id) => {
    return customAxios.get( CONFIG.apiURL + `/AdditionalPaymentLogsById/${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};
